/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_BadgeInputs */

const en_contact_badge = /** @type {(inputs: Contact_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Request a demo`)
};

/**
* | output |
* | --- |
* | "Request a demo" |
*
* @param {Contact_BadgeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const contact_badge = /** @type {((inputs?: Contact_BadgeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_BadgeInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_contact_badge(inputs)
});